import { useEffect, useState } from "react";

async function fetchProductizationSummary() {
  const response = await fetch("/api/admin/weather/colombia/risk/productization-summary", {
    headers: { Accept: "application/json" },
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error(`Unable to load risk productization summary (${response.status})`);
  }

  return response.json();
}

const WeatherRiskProductizationPanel = () => {
  const [summary, setSummary] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    let cancelled = false;

    fetchProductizationSummary()
      .then((payload) => {
        if (!cancelled) {
          setSummary(payload);
        }
      })
      .catch((error) => {
        if (!cancelled) {
          setErrorMessage(error.message || "Unable to load weather risk summary.");
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="panel-card weather-risk-productization-panel">
      <h3>Weather Risk Productization</h3>
      <p className="muted">
        Rule-based decision-support (not official emergency warnings). See{" "}
        <code>docs/weather/weather-risk-productization.md</code>.
      </p>

      {errorMessage ? <p className="muted">{errorMessage}</p> : null}

      {summary ? (
        <dl className="weather-risk-productization-panel__grid">
          <div>
            <dt>Rules version</dt>
            <dd>{summary.rulesVersion}</dd>
          </div>
          <div>
            <dt>Latest snapshot</dt>
            <dd>
              {summary.snapshots?.latestGeneratedAt
                ? new Date(summary.snapshots.latestGeneratedAt).toLocaleString()
                : "No snapshots yet"}
            </dd>
          </div>
          <div>
            <dt>Source dependencies</dt>
            <dd>{(summary.sourceDependencies || []).join(", ")}</dd>
          </div>
        </dl>
      ) : null}

      {summary?.snapshots?.byRiskLevel?.length ? (
        <>
          <h4>Recent snapshots (24h)</h4>
          <ul>
            {summary.snapshots.byRiskLevel.map((row) => (
              <li key={row.risk_level}>
                {row.risk_level}: {row.count}
              </li>
            ))}
          </ul>
        </>
      ) : null}

      <p className="muted">{summary?.disclaimer}</p>
    </section>
  );
};

export default WeatherRiskProductizationPanel;
